"use strict";
/**
 * Created by Ning Jiang on 12/3/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticReelDivider = void 0;
const BaseView_1 = require("../../core/base/BaseView");
const StageManager_1 = require("../../core/stage/StageManager");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const TimelineSprite_1 = require("../../core/animation/TimelineSprite");
class StaticReelDivider extends BaseView_1.BaseView {
    constructor(config) {
        super();
        this._dividers = [];
        this._positions = config.positions;
        this._texturesGetter = config.texturesGetter;
        this._blendMode = config.blendMode;
        this._layer = StageManager_1.StageManager.getLayer(config.layer);
        this._layer.addChild(this);
    }
    initAnimations() {
        for (let i = 0; i < this._positions.length; i++) {
            const divider = this.createDivider(i);
            this._dividers.push(divider);
            if (divider) {
                divider.x = this._positions[i][0];
                divider.y = this._positions[i][1];
                if (this._blendMode != undefined) {
                    divider.blendMode = this._blendMode;
                }
                this.addChild(divider);
            }
        }
    }
    createDivider(index) {
        const textures = this._texturesGetter(index);
        if (textures == null) {
            Logger_1.Logger.logDev(`ReelDivider.createDivider(): divider ${index} is missing image config, skip it!`);
            return null;
        }
        const sprite = new TimelineSprite_1.TimelineSprite(textures);
        sprite.anchor.x = 0.5;
        sprite.getAnimation();
        return sprite;
    }
}
exports.StaticReelDivider = StaticReelDivider;
//# sourceMappingURL=StaticReelDivider.js.map